import { DatePipe } from '@angular/common';
import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatSelect } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { BciLoaderService } from '@bci-web-core/core';
import { Chart } from 'angular-highcharts';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { CommonService } from 'src/app/services/common.service';
import {
  AppUtils,
  Constants,
  DateService,
  Highcharts$,
  Moment$,
  WarningDialog
} from 'src/app/shared/index';
import { SiteService } from '../../../../services/site.service';
import { DataTagComponent } from '../data-tag/data-tag.component';

@Component({
  selector: 'app-deep-dive',
  templateUrl: './deep-dive.component.html',
  styleUrls: ['./deep-dive.component.scss']
})
export class DeepDiveComponent implements OnInit, AfterViewInit, OnDestroy {
  loadUIRequired = false;
  loadUIDisabled = false;
  parameterUIRequired = false;
  parameterUIDisabled = false;
  form = {
    loadsAndMeters: []
  };
  siteId: string; // = (commonService.isNotSiteSpecific ? siteService.getSiteID() : commonService.siteId);

  loads = [];
  meters = [];
  dgs = [];
  params = [];
  selectLoadData = [];
  displayUpdateTagAlert = false;
  tagParameters = {
    rid: '',
    siteID: '',
    loadName: '',
    loadRID: '',
    loadID: '',
    flowChannelName: '',
    time: '',
    paramName: '',
    paramValue: '',
    tagType: '',
    tagDescription: '',
    taggedBy: '',
    paramUnit: '',
    paramDisplayValue: '',
    tagValid: '',
    modifiedTime: ''
  };
  criteria = {
    loads: [],
    params: [],
    meters: [],
    startTime: null,
    endTime: null,
    siteid: null
  };
  isMeter = false;
  displayAddTagAlert = false;
  isData = true;
  alwaysShowCalendars: boolean;
  ranges = {
    Today: [new Date(), new Date()],
    Yesterday: [
      this.dateService.subDay(new Date(), 1),
      this.dateService.subDay(new Date(), 1)
    ],
    'Last 7 days': [Moment$().subtract(6, 'days'), Moment$()]
    //'Last 30 days': [this.dateService.subDay(new Date(), 30), new Date()],
    // 'This month': [moment().startOf('month'), moment().endOf('month')]
  };

  datesSelected: any;
  deepDriveParams: any;
  areaChartConfig: any;
  loadingBar: any;

  areaChart: Chart;
  buildings: any;
  thousandSeparator: string;
  decimalSepartor: string;
  formControl = new FormControl(new Date());
  public loadMultiCtrl: FormControl = new FormControl();
  public loadMultiFilterCtrl: FormControl = new FormControl();
  public paramMultiCtrl: FormControl = new FormControl();
  public paramMultiFilterCtrl: FormControl = new FormControl();
  public buildingCtrl: FormControl = new FormControl();
  public filteredLoadsMulti: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredParamsMulti: ReplaySubject<any[]> = new ReplaySubject<any[]>(
    1
  );
  protected _onLoadDestroy = new Subject<void>();
  protected _onParamDestroy = new Subject<void>();
  @ViewChild('loadMultiSelect') loadMultiSelect: MatSelect;
  @ViewChild('paramMultiSelect') paramMultiSelect: MatSelect;

  constructor(
    private dateService: DateService,
    private datePipe: DatePipe,
    private siteService: SiteService,
    private commonService: CommonService,
    public dialog: MatDialog,
    private loader: BciLoaderService,
    private router: Router,
    private activeRoute: ActivatedRoute
  ) {
    this.siteId = this.activeRoute.snapshot.queryParams['siteId'];
    this.criteria.siteid = this.siteId;
    this.form.loadsAndMeters = [];
    this.siteService.getProcessBySiteId(this.siteId).subscribe((data) => {
      this.buildings = data;
    });
    // this.buildings = [{text: 'Exp 1', value: 'Exp 1'}, {text: 'Exp 2', value: 'Exp 2'}];
    this.thousandSeparator = AppUtils.getThousandSeparator(
      Constants.LOCALE[localStorage.getItem('siteTimezone')]
    );
    this.decimalSepartor = AppUtils.getDecimalSeparator(
      Constants.LOCALE[localStorage.getItem('siteTimezone')]
    );
  }

  ngOnInit() {
    const t = this;
    t.areaChartConfig = t.onInitChart();
    t.resetForm();
    // this.siteService.getLoadsBySiteId(t.siteId).subscribe(loadsData => {
    //   // console.log('LoadsData: ' + loadsData);
    // });
  }

  ngAfterViewInit() {
    this.setInitialLoad();
    this.setInitialParam();
  }

  ngOnDestroy() {
    if (this._onLoadDestroy) {
      this._onLoadDestroy.next();
      this._onLoadDestroy.complete();
    }

    if (this._onParamDestroy) {
      this._onParamDestroy.next();
      this._onParamDestroy.complete();
    }
  }

  initFilterLoad() {
    // load the initial bank list
    if (this.selectLoadData && this.selectLoadData.length > 0) {
      this.filteredLoadsMulti.next(this.selectLoadData.slice());
    }

    // listen for search field value changes
    this.loadMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onLoadDestroy))
      .subscribe(() => {
        this.filterLoadsMulti();
      });
  }

  initFilterParam() {
    // load the initial bank list
    this.filteredParamsMulti.next(this.deepDriveParams.slice());
    // listen for search field value changes

    this.paramMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onParamDestroy))
      .subscribe(() => {
        this.filterParamsMulti();
      });
  }
  protected setInitialLoad() {
    this.filteredLoadsMulti
      .pipe(take(1), takeUntil(this._onLoadDestroy))
      .subscribe(() => {
        this.loadMultiSelect.compareWith = (a: any, b: any) =>
          a && b && a.rId === b.rId;
      });
  }

  protected setInitialParam() {
    this.filteredParamsMulti
      .pipe(take(1), takeUntil(this._onParamDestroy))
      .subscribe(() => {
        this.paramMultiSelect.compareWith = (a: any, b: any) =>
          a && b && a === b;
      });
  }

  protected filterLoadsMulti() {
    if (!this.selectLoadData) {
      return;
    }
    // get the search keyword
    let search = this.loadMultiFilterCtrl.value;
    if (!search) {
      this.filteredLoadsMulti.next(this.selectLoadData.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the loads
    this.filteredLoadsMulti.next(
      this.selectLoadData.filter(
        (load) => load.displayText.toLowerCase().indexOf(search) > -1
      )
    );
  }
  protected filterParamsMulti() {
    if (!this.deepDriveParams) {
      return;
    }
    // get the search keyword
    let search = this.paramMultiFilterCtrl.value;
    if (!search) {
      if (this.deepDriveParams && this.deepDriveParams.length > 0) {
        this.filteredParamsMulti.next(this.deepDriveParams.slice());
      }
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the params
    this.filteredParamsMulti.next(
      this.deepDriveParams.filter(
        (param) => param.text.toLowerCase().indexOf(search) > -1
      )
    );
  }

  initLoadData(processName: string) {
    const t = this;
    // t.siteService.getLoadsBySiteId(t.siteId).subscribe(loadsData => {
    t.siteService
      .getLoadsByProcessName(t.siteId, processName)
      .subscribe((loadsData) => {
        t.loads = loadsData;
        t.loadingBar = t.loader.showProgressBar();
        const promise = t.prepareDataForLoadSelect(loadsData);
        promise.then((val) => {
          setTimeout(function () {
            t.loader.hideProgressBar(t.loadingBar);
            t.initFilterLoad();
          }, 1000);
        });
      });
  }

  prepareDataForLoadSelect(loadsData: any) {
    return new Promise((resolve, reject) => {
      const t = this;
      for (let i = 0; i < loadsData.length; i++) {
        t.selectLoadData.push(
          t.buildSelectLoadObj(loadsData[i].rId, 'load', loadsData[i].name)
        );
        if (i === loadsData.length - 1) {
          resolve(true);
        }
      }
    });
  }
  onInitChart() {
    const self = this;
    Highcharts$.setOptions({
      lang: {
        decimalPoint: self.decimalSepartor,
        thousandsSep: self.thousandSeparator
      }
    });
    return {
      chart: {
        defaultSeriesType: 'spline',
        zoomType: 'x',
        height: 600,
        borderWidth: 0.2,
        plotBorderWidth: 0.2
      },

      title: {
        text: ''
      },
      yAxis: {
        labels: {
          formatter: function () {
            return new Intl.NumberFormat(
              Constants.LOCALE[localStorage.getItem('siteTimezone')],
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }
            ).format(+this.value);
          }
        }
      },
      xAxis: {
        title: {
          text: 'Time'
        },
        type: 'datetime',
        labels: {
          formatter: function () {
            return self.commonService
              .getFormattedDate(
                localStorage.getItem('siteTimezone'),
                this.value
              )
              .format(Constants.MOMENT_DATE_FORMAT.HOURS_FORMAT_1);
          }
        },
        minRange: 10 * 1000,
        tickLength: 10,
        startOnTick: Constants.BOOLEAN_TRUE,
        endOnTick: Constants.BOOLEAN_TRUE,
        tickInterval: (3600 * 1000) / (60 * 5),
        pointInterval: (3600 * 1000) / 4,
        dateTimeLabelFormats: {
          hour: '%H:%M'
        }
      },
      plotOptions: {
        series: {
          marker: {
            enabled: Constants.BOOLEAN_TRUE
          },
          type: 'spline',
          turboThreshold: 0,
          threshold: Constants.NULL_VALUE,
          point: {
            events: {
              click: function () {}
            }
          }
        }
      },
      credits: {
        enabled: false
      },
      navigator: {
        enabled: Constants.BOOLEAN_TRUE,
        xAxis: {
          labels: {
            formatter: function () {
              return self.commonService
                .getFormattedDate(
                  localStorage.getItem('siteTimezone'),
                  this.value
                )
                .format(Constants.MOMENT_DATE_FORMAT.HOURS_FORMAT_1);
            }
          }
        }
      },
      series: [
        /*{
         name : 'Power',
         data : []
       }*/
      ],
      tooltip: {
        shared: true,
        crosshairs: true,
        formatter: function () {
          const dateStr = self.commonService
            .getFormattedDate(localStorage.getItem('siteTimezone'), this.x)
            .format(Constants.MOMENT_DATE_FORMAT.FULL_DATE_YEAR_TIME_FORMAT);
          let toolTipData =
            '<font style="font-size: 10px; font-weight: bold;">' +
            dateStr +
            '</font><br/>';

          for (let i = 0; i < this.points.length; i++) {
            const myPoint = this.points[i];
            let suffix =
              '<span style="color:' +
              myPoint.series.data[myPoint.point.index].color +
              '">\u25CF</span>   ' +
              myPoint.series.name +
              ': <b>' +
              new Intl.NumberFormat(
                Constants.LOCALE[localStorage.getItem('siteTimezone')],
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              ).format(+myPoint.y) +
              '</b><br/>';
            if (myPoint.series.name.indexOf('Data Tags') !== -1) {
              suffix =
                '<b><span style="color:' +
                myPoint.series.data[myPoint.point.index].color +
                '">\u25CF</span>  ' +
                myPoint.series.name +
                ' : Present </b><br/>';
            }
            toolTipData += suffix;
          }
          return toolTipData;
        }
      }
    };
  }
  /* Click&Navigate Trends */
  generateChart() {
    const t = this;

    if (
      Moment$(this.datesSelected.endDate).diff(
        Moment$(this.datesSelected.startDate),
        'days'
      ) > 10
    ) {
      this.onOpenAlertBox(
        'Note: Data display limited to 10 days. Please select duration not more than 10 days'
      );
    } else {
      t.criteria.startTime = t.transformDate(
        t.datesSelected.startDate.valueOf(),
        Constants.DATE.DATE_FORMAT
      );
      t.criteria.endTime = t.transformDate(
        t.datesSelected.endDate.valueOf(),
        Constants.DATE.DATE_FORMAT
      );
      t.siteService.getDeepDiveData(t.criteria).subscribe((data) => {
        this.getDataAndDrawToChart(data);
      });
    }
  }

  getDataAndDrawToChart(data: any) {
    const t = this;
    const series = Object.keys(data);
    if (series.length == 0) {
      this.isData = false;
    } else {
      this.isData = true;
      t.areaChartConfig.series = [];
      t.areaChartConfig.yAxis = [];
      let voltage = false;
      let current = false;
      let frequency = false;
      let powerfactor = false;
      let realtimepower = false;
      let realtimeenergy = false;
      let registerenergy = false;
      let ambient_temp = false;
      let ambient_pressure = false;
      let CFM = false;
      let fuelConsumption = false;
      let irdSensorReading = false;
      let dataTags = false;
      let right = false;
      let partCounter = false;
      let thd_ia = false,
        thd_ib = false,
        thd_ic = false,
        thd_i = false;
      let thd_va = false,
        thd_vb = false,
        thd_vc = false,
        thd_v = false;
      let h3_ia = false,
        h3_ib = false,
        h3_ic = false;
      let h3_va = false,
        h3_vb = false,
        h3_vc = false;
      let h5_ia = false,
        h5_ib = false,
        h5_ic = false;
      let h5_va = false,
        h5_vb = false,
        h5_vc = false;
      let h7_ia = false,
        h7_ib = false,
        h7_ic = false;
      let h7_va = false,
        h7_vb = false,
        h7_vc = false;
      for (let i = 0; i < series.length; i++) {
        let id = '';
        if (series[i].indexOf('voltage') !== -1) {
          id = 'V';
          if (!voltage) {
            t.addYAxis(id, id, right);
            voltage = true;
            right = !right;
          }
        } else if (series[i].indexOf('current') !== -1) {
          id = 'Amperes';
          if (!current) {
            t.addYAxis(id, id, right);
            current = true;
            right = !right;
          }
        } else if (series[i].indexOf('Frequency') !== -1) {
          id = 'Hz';
          if (!frequency) {
            t.addYAxis(id, id, right);
            frequency = true;
            right = !right;
          }
        } else if (series[i].indexOf('powerfactor') !== -1) {
          id = 'Powerfactor';
          if (!powerfactor) {
            t.addYAxis(id, id, right);
            powerfactor = true;
            right = !right;
          }
        } else if (series[i].indexOf('realtimepower') !== -1) {
          id = 'kW';
          if (!realtimepower) {
            t.addYAxis(id, id, right);
            realtimepower = true;
            right = !right;
          }
        } else if (series[i].indexOf('realtimeenergy') !== -1) {
          id = 'kWH';
          if (!realtimeenergy) {
            t.addYAxis(id, id, right);
            realtimeenergy = true;
            right = !right;
          }
        } else if (series[i].indexOf('registerenergy') !== -1) {
          id = 'kWH';
          if (!registerenergy) {
            t.addYAxis(id, id, right);
            registerenergy = true;
            right = !right;
          }
        } else if (series[i].indexOf('ambient_temp') !== -1) {
          id = 'degree C';
          if (!ambient_temp) {
            t.addYAxis(id, id, right);
            ambient_temp = true;
            right = !right;
          }
        } else if (series[i].indexOf('ambient_pressure') !== -1) {
          id = 'psi';
          if (!ambient_pressure) {
            t.addYAxis(id, id, right);
            ambient_pressure = true;
            right = !right;
          }
        } else if (series[i].indexOf('CFM') !== -1) {
          id = 'CFM';
          if (!CFM) {
            t.addYAxis(id, id, right);
            CFM = true;
            right = !right;
          }
        } else if (series[i].indexOf('fuelConsumption') !== -1) {
          id = 'Litres';
          if (!fuelConsumption) {
            t.addYAxis(id, id, right);
            fuelConsumption = true;
            right = !right;
          }
        } else if (series[i].indexOf('IrradiationSensorOutput') !== -1) {
          id = 'Units';
          if (!irdSensorReading) {
            t.addYAxis(id, id, right);
            irdSensorReading = true;
            right = !right;
          }
        } else if (series[i].indexOf('Data Tags') !== -1) {
          id = 'Data Tags';
          if (!dataTags) {
            t.addYAxis(id, id, false);
            dataTags = true;
          }
        } else if (series[i].indexOf('partCounter') !== -1) {
          id = 'Units';
          if (!partCounter) {
            t.addYAxis(id, id, false);
            partCounter = true;
          }
        } else if (series[i].indexOf('thd_ia') != -1) {
          id = 'Amperes';
          if (!thd_ia) {
            t.addYAxis(id, id, right);
            thd_ia = true;
            right = !right;
          }
        } else if (series[i].indexOf('thd_ib') != -1) {
          id = 'Amperes';
          if (!thd_ib) {
            t.addYAxis(id, id, right);
            thd_ib = true;
            right = !right;
          }
        } else if (series[i].indexOf('thd_ic') != -1) {
          id = 'Amperes';
          if (!thd_ic) {
            t.addYAxis(id, id, right);
            thd_ic = true;
            right = !right;
          }
        } else if (series[i].indexOf('thd_i') != -1) {
          id = 'Amperes';
          if (!thd_i) {
            t.addYAxis(id, id, right);
            thd_i = true;
            right = !right;
          }
        } else if (series[i].indexOf('thd_va') != -1) {
          id = 'V';
          if (!thd_va) {
            t.addYAxis(id, id, right);
            thd_va = true;
            right = !right;
          }
        } else if (series[i].indexOf('thd_vb') != -1) {
          id = 'V';
          if (!thd_vb) {
            t.addYAxis(id, id, right);
            thd_vb = true;
            right = !right;
          }
        } else if (series[i].indexOf('thd_vc') != -1) {
          id = 'V';
          if (!thd_vc) {
            t.addYAxis(id, id, right);
            thd_vc = true;
            right = !right;
          }
        } else if (series[i].indexOf('thd_v') != -1) {
          id = 'V';
          if (!thd_v) {
            t.addYAxis(id, id, right);
            thd_v = true;
            right = !right;
          }
        } else if (series[i].indexOf('h3_ia') != -1) {
          id = 'Amperes';
          if (!h3_ia) {
            t.addYAxis(id, id, right);
            h3_ia = true;
            right = !right;
          }
        } else if (series[i].indexOf('h3_ib') != -1) {
          id = 'Amperes';
          if (!h3_ib) {
            t.addYAxis(id, id, right);
            h3_ib = true;
            right = !right;
          }
        } else if (series[i].indexOf('h3_ic') != -1) {
          id = 'Amperes';
          if (!h3_ic) {
            t.addYAxis(id, id, right);
            h3_ic = true;
            right = !right;
          }
        } else if (series[i].indexOf('h3_va') != -1) {
          id = 'V';
          if (!h3_va) {
            t.addYAxis(id, id, right);
            h3_va = true;
            right = !right;
          }
        } else if (series[i].indexOf('h3_vb') != -1) {
          id = 'V';
          if (!h3_vb) {
            t.addYAxis(id, id, right);
            h3_vb = true;
            right = !right;
          }
        } else if (series[i].indexOf('h3_vc') != -1) {
          id = 'V';
          if (!h3_vc) {
            t.addYAxis(id, id, right);
            h3_vc = true;
            right = !right;
          }
        } else if (series[i].indexOf('h5_ia') != -1) {
          id = 'Amperes';
          if (!h5_ia) {
            t.addYAxis(id, id, right);
            h5_ia = true;
            right = !right;
          }
        } else if (series[i].indexOf('h5_ib') != -1) {
          id = 'Amperes';
          if (!h5_ib) {
            t.addYAxis(id, id, right);
            h5_ib = true;
            right = !right;
          }
        } else if (series[i].indexOf('h5_ic') != -1) {
          id = 'Amperes';
          if (!h5_ic) {
            t.addYAxis(id, id, right);
            h5_ic = true;
            right = !right;
          }
        } else if (series[i].indexOf('h5_va') != -1) {
          id = 'V';
          if (!h5_va) {
            t.addYAxis(id, id, right);
            h5_va = true;
            right = !right;
          }
        } else if (series[i].indexOf('h5_vb') != -1) {
          id = 'V';
          if (!h5_vb) {
            t.addYAxis(id, id, right);
            h5_vb = true;
            right = !right;
          }
        } else if (series[i].indexOf('h5_vc') != -1) {
          id = 'V';
          if (!h5_vc) {
            t.addYAxis(id, id, right);
            h5_vc = true;
            right = !right;
          }
        } else if (series[i].indexOf('h7_ia') != -1) {
          id = 'Amperes';
          if (!h7_ia) {
            t.addYAxis(id, id, right);
            h7_ia = true;
            right = !right;
          }
        } else if (series[i].indexOf('h7_ib') != -1) {
          id = 'Amperes';
          if (!h7_ib) {
            t.addYAxis(id, id, right);
            h7_ib = true;
            right = !right;
          }
        } else if (series[i].indexOf('h7_ic') != -1) {
          id = 'Amperes';
          if (!h7_ic) {
            t.addYAxis(id, id, right);
            h7_ic = true;
            right = !right;
          }
        } else if (series[i].indexOf('h7_va') != -1) {
          id = 'V';
          if (!h7_va) {
            t.addYAxis(id, id, right);
            h7_va = true;
            right = !right;
          }
        } else if (series[i].indexOf('h7_vb') != -1) {
          id = 'V';
          if (!h7_vb) {
            t.addYAxis(id, id, right);
            h7_vb = true;
            right = !right;
          }
        } else if (series[i].indexOf('h7_vc') != -1) {
          id = 'V';
          if (!h7_vc) {
            t.addYAxis(id, id, right);
            h7_vc = true;
            right = !right;
          }
        }
        t.addXAxis(series[i], data[series[i]], id);
      }
      t.areaChartConfig.plotOptions.series.point.events.click =
        t.customDataPointClick;
      t.areaChart = new Chart(t.areaChartConfig);
    }
  }

  customDataPointClick = (event: any) => {
    const point = event.point; // series.name
    if (point.series.name !== 'Data Tags') {
      const tagtxtime = Moment$(point.x).format(
        Constants.MOMENT_DATE_FORMAT.FULL_DATE_FORMAT_1
      );
      const paramName = point.series.name;
      const paramValue = point.y;
      const paramUnit = ' ';
      const tagDesc = '';
      this.setTagDetails(tagtxtime, paramName, paramValue);
      if (!this.isMeter) {
        // Open Modal
        const dialogConfig: MatDialogConfig = {
          // height: '80%',
          width: '70%',
          data: {
            tagParameters: this.tagParameters,
            fromDate: this.criteria.startTime,
            toDate: this.criteria.endTime
          }
        };
        // Open View Existing Tags Accordion
        this.dialog.open(DataTagComponent, dialogConfig);
      } else {
        this.onOpenAlertBox(
          'Data Tagging feature is not available for Mains Meters as of now'
        );
      }
    }
  };

  addYAxis(id, text, opposite) {
    const t = this;
    if (id === 'Data Tags') {
      t.areaChartConfig.yAxis.push({
        id: id,
        title: {
          text: ''
        },
        labels: {
          formatter: function () {
            return new Intl.NumberFormat(
              Constants.LOCALE[localStorage.getItem('siteTimezone')],
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }
            ).format(+this.value);
          }
        },
        opposite: opposite
      });
    } else {
      t.areaChartConfig.yAxis.push({
        id: id,
        title: {
          text: text
        },
        labels: {
          formatter: function () {
            return new Intl.NumberFormat(
              Constants.LOCALE[localStorage.getItem('siteTimezone')],
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }
            ).format(+this.value);
          }
        },
        opposite: opposite
      });
    }
  }

  addXAxis(name, data, yAxisId) {
    const t = this;
    if (yAxisId === 'Data Tags') {
      t.areaChartConfig.series.push({
        name: name,
        data: data,
        yAxis: yAxisId,
        lineWidth: 0,
        states: {
          hover: {
            lineWidthPlus: 0
          }
        },
        marker: {
          enabled: true,
          // symbol: 'url(https://www.highcharts.com/samples/graphics/sun.png)'
          symbol: 'url(resources/img/data_tag_redflag.png)'
        }
      });
    } else {
      t.areaChartConfig.series.push({
        name: name,
        data: data,
        yAxis: yAxisId
      });
    }
  }

  resetForm() {
    const t = this;
    this.loadMultiCtrl.setValue('');
    this.buildingCtrl.setValue('');
    t.params = [];
    t.datesSelected = null;

    const d = new Date();
    d.setDate(d.getDate() - 1);
    t.datesSelected = { startDate: d, endDate: d };
    t.criteria = {
      loads: [],
      params: [],
      meters: [],
      startTime: t.transformDate(
        t.datesSelected.startDate.valueOf(),
        Constants.DATE.DATE_FORMAT
      ),
      endTime: t.transformDate(
        t.datesSelected.endDate.valueOf(),
        Constants.DATE.DATE_FORMAT
      ),
      siteid: t.siteId
    };

    if (t.areaChart) {
      t.areaChart.destroy();
    }
  }

  goBack() {
    // this.router.navigate(['energy-dashboard', 'energy'], { queryParams: { siteId: this.siteId } });
  }

  changeDateRange(event) {
    if (this.commonService.isLaterThanCurentDate(this.datesSelected.endDate)) {
      this.commonService.showDialogMessage(Constants.FUTURE_DATE_NOT_ALLOW);
      return;
    }
  }
  private onOpenAlertBox = (description: string) => {
    const dialogRef = this.dialog.open(WarningDialog, { width: '50%' });
    dialogRef.componentInstance.confirmMessage = description;
  };

  buildSelectLoadObj(rId, type, displayText) {
    return {
      rId: rId,
      type: type,
      displayText: displayText
    };
  }
  buildParams(event) {
    const t = this;
    t.buildLoadsAndMetersForCriteria();

    const promise = t.buildDeepDriveParams();
    promise.then((val) => {
      t.initFilterParam();
    });
  }
  selectBuildingChange(event: any) {
    this.loadMultiSelect.options.forEach((k) => k.deselect());
    this.selectLoadData = [];
    this.initLoadData(event.value.toString());
  }
  buildDeepDriveParams() {
    return new Promise((resolve, reject) => {
      const t = this;
      t.deepDriveParams = [];
      if (t.criteria.meters.length > 0) {
        t.deepDriveParams = t.commonService.buildLoadParams(
          { parameters: [] },
          false
        );
      } else {
        for (let i = 0; i < t.criteria.loads.length; i++) {
          const load = t.criteria.loads[i];
          const loadParamArr = t.commonService.buildLoadParams(load, false);
          for (let j = 0; j < loadParamArr.length; j++) {
            let found = false;
            for (let k = 0; k < t.params.length; k++) {
              if (loadParamArr[j] === t.params[k]) {
                found = true;
                break;
              }
            }
            if (!found) {
              t.deepDriveParams.push(loadParamArr[j]);
            }
          }
        }
      }
      resolve(true);
    });
  }
  buildLoadsAndMetersForCriteria() {
    const t = this;
    t.criteria.loads = [];
    t.criteria.meters = [];

    for (let i = 0; i < t.form.loadsAndMeters.length; i++) {
      if (t.form.loadsAndMeters[i]) {
        for (let j = 0; j < t.loads.length; j++) {
          if (t.form.loadsAndMeters[i].displayText == t.loads[j].name) {
            if (t.form.loadsAndMeters[i].type === 'load') {
              t.criteria.loads.push(t.loads[j]);
            } else {
              t.criteria.meters.push(t.loads[j]);
            }
          }
        }
      }
    }
  }

  findByRId(arr, rId) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].rId === rId) {
        return arr[i];
      }
    }
  }
  transformDate(date: any, format: string): string {
    return this.datePipe.transform(date, format) || '';
  }
  private setTagDetails = (
    tagtxtime: string,
    paramName: string,
    paramValue: string
  ) => {
    const t = this;
    t.tagParameters.taggedBy = 'admin'; // update later .commonService.username
    t.tagParameters.paramName = paramName;
    t.tagParameters.time = tagtxtime;
    t.tagParameters.siteID = t.siteId;
    t.displayUpdateTagAlert = false;
    t.tagParameters.flowChannelName = '';

    t.tagParameters.tagType = '';
    t.tagParameters.tagDescription = '';
    let unit;

    if (paramName.indexOf('voltage') !== -1) {
      unit = 'V';
    } else if (paramName.indexOf('current') !== -1) {
      unit = 'Amperes';
    } else if (paramName.indexOf('Frequency') !== -1) {
      unit = 'Hz';
    } else if (paramName.indexOf('powerfactor') !== -1) {
      unit = 'Powerfactor';
    } else if (paramName.indexOf('realtimepower') !== -1) {
      unit = 'kW';
    } else if (paramName.indexOf('realtimeenergy') !== -1) {
      unit = 'kWH';
    } else if (paramName.indexOf('registerenergy') !== -1) {
      unit = 'kWH';
    } else if (paramName.indexOf('ambient_temp') !== -1) {
      unit = 'degree C';
    } else if (paramName.indexOf('ambient_pressure') !== -1) {
      unit = 'psi';
    } else if (paramName.indexOf('CFM') !== -1) {
      unit = 'L';
    } else if (paramName.indexOf('fuelConsumption') !== -1) {
      unit = 'litres';
    }

    t.tagParameters.paramValue = paramValue;
    t.tagParameters.paramUnit = unit;
    t.tagParameters.paramDisplayValue = paramValue + ' ' + unit;

    for (let i = 0; i < t.params.length; i++) {
      if (paramName.indexOf(t.params[i].text) !== -1) {
        t.tagParameters.paramName = t.params[i].text;
      }
    }

    for (let i = 0; i < t.selectLoadData.length; i++) {
      if (paramName.indexOf(t.selectLoadData[i].displayText) !== -1) {
        t.tagParameters.loadName = t.selectLoadData[i].displayText;
        t.tagParameters.loadRID = t.selectLoadData[i].rId;
        if (t.selectLoadData[i].type === 'meter') {
          t.isMeter = true;
        } else {
          t.isMeter = false;
        }
      }
    }
  };
}
